import React, {Component} from 'react'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import { handleAppError } from '../handlers';
import { message } from 'antd'
import { locationOutline, search_icon } from '../../assets/images';

function new_script(src) {
  return new Promise(function(resolve, reject){
    var script = document.createElement('script');
    script.src = src;
    script.addEventListener('load', function () {
      resolve();
    });
    script.addEventListener('error', function (e) {
      reject(e);
    });
    document.body.appendChild(script);
  })
};
// Promise Interface can ensure load the script only once.
var my_script = new_script('https://maps.googleapis.com/maps/api/js?key=AIzaSyD9zjUeIvgdywGQz-YfLX-TKNp28xGlgAQ&libraries=places');

class UserLocationModal extends Component {
  constructor(props) {
    super(props)
    this.state = { 
      addresses: {},
      address: this.props.addressValue,
      geocodeResults: null,
      loading: false,
      value: this.props.addressValue,
      placeholder: this.props.placeholder ?? 'Search places',
      inputClasses: this.props.inputClasses,
      inputStyle: this.props.inputStyle,
      dropdownStyle: this.props.dropdownStyle ?? {width: '100%'},
      dropdownClasses: this.props.dropdownClasses 
    }
    this.handleSelect = this.handleSelect.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.renderGeocodeFailure = this.renderGeocodeFailure.bind(this)
    this.renderGeocodeSuccess = this.renderGeocodeSuccess.bind(this)
  }

  do_load = () => {
    var self = this;
    my_script.then(function() {
      self.setState({'status': 'done'});
    }).catch(function() {
      self.setState({'status': 'error'});
    })
  }
  
  handleSelect(address) {
    this.setState({
      address,
      loading: true,
      value: address
    })

    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        this.setState({
          geocodeResults: this.renderGeocodeSuccess(lat, lng, address),
          loading: false
        })
        this.props.onSet({lat, lng, address})
      })
      .catch((error) => {
        this.setState({
          geocodeResults: this.renderGeocodeFailure(error),
          loading: false
        })
      })
  }

  handleChange(address) {
    this.setState({
      address,
      geocodeResults: null
    })
  }

  renderGeocodeFailure(err) {
    return (
      <div className="alert alert-danger" role="alert">
        <strong>Error!</strong> {err}
      </div>
    )
  }

  renderGeocodeSuccess = (lat, lng, address) => {

    if(this.props.benefitType != 'ahc' && this.props.customerId){
    const that = this
    let url = window.API_URL + "corporate/customers/" + that.props.customerId + "/update_location"
    window.axios.post(url, {addresses: {lat: lat, lng: lng, address: address}})
    .then(function (response){
      that.setState({})
    })
    .catch(function (error){
      handleAppError(error)
    })}
  }

  handleLoadError = (error) => {  
    error === 'ZERO_RESULTS' ? message.error('Location not found' ) : console.error('Error loading Google Maps API', error)
  }

  render() {

    const renderSuggestionsDropdown = ({ getInputProps, getSuggestionItemProps, suggestions }) => (
      <div className="autocomplete-root relative ">
        <div className={'flex border-gray-200 bg-white border ' + this.state.inputClasses} style={this.state.inputStyle}>
          <img src={search_icon} className='inline-block ml-3 mr-2' />
          <input {...getInputProps()} placeholder={this.state.placeholder} style={{ borderColor: 'transparent'}} className='location text-gray-600 text-base leading-4 align-baseline w-full border-transparent pl-0 mr-1'/>
        </div>
        <div className={`autocomplete-dropdown-container ${suggestions.length > 0 ? `border-gray-200 border rounded-md mt-2 ${this.state.dropdownClasses}` : ''}`} style={this.state.dropdownStyle}>

          {suggestions.map((suggestion, index) => (
            <div className=''>
            <div key={index} className='p-2 text-gray-600 bg-white flex items-center hover:bg-gray-100 hover:text-gray-900 ' {...getSuggestionItemProps(suggestion)}>
              <img src={locationOutline} className='h-5 mr-2'/>
              <span className='cursor-pointer '>{suggestion.description}</span>
            </div>
            <hr size="8" width="100%"></hr>
            </div>
            
          ))}
        </div>
      </div>
    );

    return (
      <PlacesAutocomplete
        value={this.state.value}
        onChange={value => this.setState({ value })}
        onSelect={this.handleSelect}
        onEnterKeyDown={this.handleSelect}
        onError={this.handleLoadError}
        debounce={500}
        shouldFetchSuggestions={this.state.value?.length > 2}
        searchOptions={{}}
      >{renderSuggestionsDropdown}
      </PlacesAutocomplete>
    )
  }
}

export default UserLocationModal